// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'https://localhost:7172' | (string & {});
};

export type AddFolderPermissionsRequest = {
    exchangeFolderId: string;
    changePermissionsInput: PermissionChangeRequest;
    applyRecursive?: boolean;
};

export type ApiErrorResponse = {
    traceId: string;
    timestamp?: string;
    statusCode?: number;
    message: string;
};

export type ApplyPermissionsAllRequest = {
    graphFolderId: string;
    exchangeFolderId: string;
};

export type ApplyPermissionsSelectedRequest = {
    graphFolderId: string;
    exchangeFolderId: string;
    targetGraphFolderIds: Array<string>;
};

export type DirectoryUserResponse = {
    mail?: string | null;
    displayName?: string | null;
};

export type FolderChangeOutcomeResponse = {
    graphFolderId?: string;
    succeeded?: boolean;
    failure?: string | null;
};

export enum FolderPermissionLevel {
    NONE = 'None',
    OWNER = 'Owner',
    PUBLISHING_EDITOR = 'PublishingEditor',
    EDITOR = 'Editor',
    PUBLISHING_AUTHOR = 'PublishingAuthor',
    AUTHOR = 'Author',
    NONEDITING_AUTHOR = 'NoneditingAuthor',
    REVIEWER = 'Reviewer',
    CONTRIBUTOR = 'Contributor',
    FREE_BUSY_TIME_ONLY = 'FreeBusyTimeOnly',
    FREE_BUSY_TIME_AND_SUBJECT_AND_LOCATION = 'FreeBusyTimeAndSubjectAndLocation',
    CUSTOM = 'Custom'
}

export enum FolderPermissionReadAccess {
    NONE = 'None',
    TIME_ONLY = 'TimeOnly',
    TIME_AND_SUBJECT_AND_LOCATION = 'TimeAndSubjectAndLocation',
    FULL_DETAILS = 'FullDetails'
}

export type FolderPermissionResponse = {
    user?: string | null;
    email?: string | null;
    canCreateItems?: boolean;
    canCreateSubFolders?: boolean;
    isFolderOwner?: boolean;
    isFolderVisible?: boolean;
    isFolderContact?: boolean;
    permissionLevel?: FolderPermissionLevel;
    readItems?: FolderPermissionReadAccess;
    deleteItems?: PermissionScope;
    editItems?: PermissionScope;
};

export type FolderPermissionsResponse = {
    permissions?: Array<FolderPermissionResponse>;
};

export type MailFolderResponse = {
    graphFolderId: string;
    exchangeFolderId: string;
    folderName?: string | null;
    hasChildFolders?: boolean | null;
};

export type OperationResultResponse = {
    message?: string;
    changedCount?: number;
    failedCount?: number;
    outcomes?: Array<FolderChangeOutcomeResponse>;
};

export type PermissionChangeRequest = {
    userMailCollection: Array<string>;
    permissionLevel?: FolderPermissionLevel;
    readItems?: FolderPermissionReadAccess;
    deleteItems?: PermissionScope;
    editItems?: PermissionScope;
    canCreateItems?: boolean;
    canCreateSubfolders?: boolean;
    isFolderContact?: boolean;
    isFolderOwner?: boolean;
    isFolderVisible?: boolean;
};

export enum PermissionScope {
    NONE = 'None',
    OWNED = 'Owned',
    ALL = 'All'
}

export type RemoveFolderPermissionRequest = {
    exchangeFolderId: string;
    targetUserEmail: string;
    applyRecursive?: boolean;
};

export type SmartLicense = {
    client?: string | null;
    domains?: Array<string>;
    subscriptionType?: SubscriptionType;
    expiry?: string | null;
    productGuid?: string;
    isLicensed?: boolean;
};

export enum SubscriptionType {
    PRO_USER = 'ProUser',
    FLAT_RATE = 'FlatRate',
    WAITING = 'Waiting',
    NOT_LICENSED = 'NotLicensed'
}

export type UpdateFolderPermissionsRequest = {
    exchangeFolderId: string;
    changePermissionsInput: PermissionChangeRequest;
    applyRecursive?: boolean;
};

export type GetApiDirectoryUsersData = {
    body?: never;
    path?: never;
    query?: {
        SearchString?: string;
    };
    url: '/api/directory-users';
};

export type GetApiDirectoryUsersErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type GetApiDirectoryUsersError = GetApiDirectoryUsersErrors[keyof GetApiDirectoryUsersErrors];

export type GetApiDirectoryUsersResponses = {
    /**
     * OK
     */
    200: Array<DirectoryUserResponse>;
};

export type GetApiDirectoryUsersResponse = GetApiDirectoryUsersResponses[keyof GetApiDirectoryUsersResponses];

export type GetApiFolderPermissionsByGraphFolderIdData = {
    body?: never;
    path: {
        graphFolderId: string;
    };
    query: {
        exchangeFolderId: string;
    };
    url: '/api/folder-permissions/{graphFolderId}';
};

export type GetApiFolderPermissionsByGraphFolderIdErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type GetApiFolderPermissionsByGraphFolderIdError = GetApiFolderPermissionsByGraphFolderIdErrors[keyof GetApiFolderPermissionsByGraphFolderIdErrors];

export type GetApiFolderPermissionsByGraphFolderIdResponses = {
    /**
     * OK
     */
    200: FolderPermissionsResponse;
};

export type GetApiFolderPermissionsByGraphFolderIdResponse = GetApiFolderPermissionsByGraphFolderIdResponses[keyof GetApiFolderPermissionsByGraphFolderIdResponses];

export type PostApiFolderPermissionsApplyAllData = {
    body?: ApplyPermissionsAllRequest;
    path?: never;
    query?: never;
    url: '/api/folder-permissions/apply-all';
};

export type PostApiFolderPermissionsApplyAllErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type PostApiFolderPermissionsApplyAllError = PostApiFolderPermissionsApplyAllErrors[keyof PostApiFolderPermissionsApplyAllErrors];

export type PostApiFolderPermissionsApplyAllResponses = {
    /**
     * OK
     */
    200: OperationResultResponse;
};

export type PostApiFolderPermissionsApplyAllResponse = PostApiFolderPermissionsApplyAllResponses[keyof PostApiFolderPermissionsApplyAllResponses];

export type PostApiFolderPermissionsApplySelectedData = {
    body?: ApplyPermissionsSelectedRequest;
    path?: never;
    query?: never;
    url: '/api/folder-permissions/apply-selected';
};

export type PostApiFolderPermissionsApplySelectedErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type PostApiFolderPermissionsApplySelectedError = PostApiFolderPermissionsApplySelectedErrors[keyof PostApiFolderPermissionsApplySelectedErrors];

export type PostApiFolderPermissionsApplySelectedResponses = {
    /**
     * OK
     */
    200: OperationResultResponse;
};

export type PostApiFolderPermissionsApplySelectedResponse = PostApiFolderPermissionsApplySelectedResponses[keyof PostApiFolderPermissionsApplySelectedResponses];

export type PostApiFolderPermissionsByGraphFolderIdAddData = {
    body?: AddFolderPermissionsRequest;
    path: {
        graphFolderId: string;
    };
    query?: never;
    url: '/api/folder-permissions/{graphFolderId}/add';
};

export type PostApiFolderPermissionsByGraphFolderIdAddErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type PostApiFolderPermissionsByGraphFolderIdAddError = PostApiFolderPermissionsByGraphFolderIdAddErrors[keyof PostApiFolderPermissionsByGraphFolderIdAddErrors];

export type PostApiFolderPermissionsByGraphFolderIdAddResponses = {
    /**
     * OK
     */
    200: OperationResultResponse;
};

export type PostApiFolderPermissionsByGraphFolderIdAddResponse = PostApiFolderPermissionsByGraphFolderIdAddResponses[keyof PostApiFolderPermissionsByGraphFolderIdAddResponses];

export type DeleteApiFolderPermissionsByGraphFolderIdRemoveData = {
    body?: RemoveFolderPermissionRequest;
    path: {
        graphFolderId: string;
    };
    query?: never;
    url: '/api/folder-permissions/{graphFolderId}/remove';
};

export type DeleteApiFolderPermissionsByGraphFolderIdRemoveErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type DeleteApiFolderPermissionsByGraphFolderIdRemoveError = DeleteApiFolderPermissionsByGraphFolderIdRemoveErrors[keyof DeleteApiFolderPermissionsByGraphFolderIdRemoveErrors];

export type DeleteApiFolderPermissionsByGraphFolderIdRemoveResponses = {
    /**
     * OK
     */
    200: OperationResultResponse;
};

export type DeleteApiFolderPermissionsByGraphFolderIdRemoveResponse = DeleteApiFolderPermissionsByGraphFolderIdRemoveResponses[keyof DeleteApiFolderPermissionsByGraphFolderIdRemoveResponses];

export type PutApiFolderPermissionsByGraphFolderIdUpdateData = {
    body?: UpdateFolderPermissionsRequest;
    path: {
        graphFolderId: string;
    };
    query?: never;
    url: '/api/folder-permissions/{graphFolderId}/update';
};

export type PutApiFolderPermissionsByGraphFolderIdUpdateErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type PutApiFolderPermissionsByGraphFolderIdUpdateError = PutApiFolderPermissionsByGraphFolderIdUpdateErrors[keyof PutApiFolderPermissionsByGraphFolderIdUpdateErrors];

export type PutApiFolderPermissionsByGraphFolderIdUpdateResponses = {
    /**
     * OK
     */
    200: OperationResultResponse;
};

export type PutApiFolderPermissionsByGraphFolderIdUpdateResponse = PutApiFolderPermissionsByGraphFolderIdUpdateResponses[keyof PutApiFolderPermissionsByGraphFolderIdUpdateResponses];

export type GetApiLicensingCheckData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/licensing/check';
};

export type GetApiLicensingCheckErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type GetApiLicensingCheckError = GetApiLicensingCheckErrors[keyof GetApiLicensingCheckErrors];

export type GetApiLicensingCheckResponses = {
    /**
     * OK
     */
    200: boolean;
};

export type GetApiLicensingCheckResponse = GetApiLicensingCheckResponses[keyof GetApiLicensingCheckResponses];

export type GetApiLicensingCurrentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/licensing/current';
};

export type GetApiLicensingCurrentErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type GetApiLicensingCurrentError = GetApiLicensingCurrentErrors[keyof GetApiLicensingCurrentErrors];

export type GetApiLicensingCurrentResponses = {
    /**
     * OK
     */
    200: SmartLicense;
};

export type GetApiLicensingCurrentResponse = GetApiLicensingCurrentResponses[keyof GetApiLicensingCurrentResponses];

export type GetApiLicensingVersionData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/licensing/version';
};

export type GetApiLicensingVersionErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type GetApiLicensingVersionError = GetApiLicensingVersionErrors[keyof GetApiLicensingVersionErrors];

export type GetApiLicensingVersionResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetApiLicensingVersionResponse = GetApiLicensingVersionResponses[keyof GetApiLicensingVersionResponses];

export type GetApiMailFoldersData = {
    body?: never;
    path?: never;
    query?: {
        ParentGraphFolderId?: string;
    };
    url: '/api/mail-folders';
};

export type GetApiMailFoldersErrors = {
    /**
     * Bad Request
     */
    400: ApiErrorResponse;
    /**
     * Internal Server Error
     */
    500: ApiErrorResponse;
};

export type GetApiMailFoldersError = GetApiMailFoldersErrors[keyof GetApiMailFoldersErrors];

export type GetApiMailFoldersResponses = {
    /**
     * OK
     */
    200: Array<MailFolderResponse>;
};

export type GetApiMailFoldersResponse = GetApiMailFoldersResponses[keyof GetApiMailFoldersResponses];
